document.addEventListener("DOMContentLoaded", function(event) {  
  
      let favBtn = document.querySelector('body');
      const firstBtn = document.querySelector('.wishlist_btn');
      if (!firstBtn) return;
      let customer = firstBtn.dataset.customer;
      let productHandle = firstBtn.dataset.productHandle;

      if(customer){
                let today = new Date();
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let fav_url = 'https://clnf.vercel.app/api/wishlist/get?customer='+encodeURIComponent(customer)+'&handle='+encodeURIComponent(productHandle)+'&action=getdata&time='+encodeURIComponent(time);
        fetch(fav_url)
        .then(res => res.json())
        .then(data => {
          if (!Array.isArray(data) || data.length === 0) return;
        let handle = data.find(e => {return e.handle});
          showActiveProducts(handle.handle);

        })
        .catch(() => {})
        
     }
  

  favBtn.addEventListener('click', function(e){
    let favBtnClicked = e.target.closest('.wishlist_btn');
    if(!favBtnClicked) return;

    let productTitle = favBtnClicked.dataset.productTitle;
    let productImg = favBtnClicked.dataset.productImg;
    let productVid = favBtnClicked.dataset.vid;
    let productVsize = favBtnClicked.dataset.vsize;

    getProductData(productHandle);
    showActiveProducts(productHandle);

    if(customer){
      let hasClass = favBtnClicked.classList.contains('active--favorites');
      let is_selected = "false";
      if(hasClass){
        is_selected="true";
      }else{
        is_selected="false";
      }

      let today = new Date();
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      // let fav_url = 'https://isaach14.sg-host.com/clnf/index.php?customer='+customer+'&handle='+productHandle+'&active='+is_selected+'&action=setdata'+'&ptitle='+productTitle+'&pimg='+productImg+'&vid='+productVid+'&vsize='+productVsize+'&time='+time;
      let fav_url = `https://clnf.vercel.app/api/wishlist/add?customer=${encodeURIComponent(customer)}&handle=${encodeURIComponent(productHandle)}&active=${is_selected}&action=setdata&ptitle=${encodeURIComponent(productTitle)}&pimg=${encodeURIComponent(productImg)}&vid=${encodeURIComponent(productVid)}&vsize=${encodeURIComponent(productVsize)}&time=${encodeURIComponent(time)}`;
        fetch(fav_url).then(res => res.json()).then(data => {
          // localStorage.setItem('wishlistData', JSON.stringify(data));
          
          // Track wishlist action
          if (window.trackWishlistAction) {
              const action = is_selected === "true" ? "removed" : "added";
              window.trackWishlistAction(action, {
                  product_id: productVid,
                  product_title: productTitle
              });
          }
        })
        .catch(() => {})
      
    }else{
      window.location.href="/account";
    }
    
  });

  const showActiveProducts = function(productHandle){

    if(document.querySelector(`.wishlist_btn.active--favorites[data-product-handle="${productHandle}"] `)){
    document.querySelector(`.wishlist_btn[data-product-handle="${productHandle}"] `).classList.remove('active--favorites');
    document.querySelector(`.wishlist_btn[data-product-handle="${productHandle}"] .fav_text `).innerHTML = 'Add To Favorites';
    }else{
    // if(productsArray == null) return;

        let activeTag = document.querySelector(`.wishlist_btn[data-product-handle="${productHandle}"] `);
        if(activeTag != null){
          activeTag.classList.add('active--favorites');
          activeTag.querySelector('.fav_text').innerHTML = 'Added To Account';
        }
    }

    

    
  }


  const getProductData = function(productHandle){

    let favoritesproductLocal = localStorage.getItem('favorites_products');

    const allfavoritesProducts = [];

    if(favoritesproductLocal == null){
		
        allfavoritesProducts.push(productHandle);
        localStorage.setItem('favorites_products', JSON.stringify(allfavoritesProducts));

    }else{
        try { favoritesproductLocal = JSON.parse(localStorage.getItem('favorites_products')); } catch(e) { localStorage.removeItem('favorites_products'); return; }
        let productAlreadyexists = favoritesproductLocal.some((any, i) => productHandle == any);
      if(productAlreadyexists){
        let onlySelectedProducts = favoritesproductLocal.filter(any => productHandle != any);
        localStorage.setItem('favorites_products', JSON.stringify(onlySelectedProducts));
      }else{
        allfavoritesProducts.push(productHandle);
        localStorage.setItem('favorites_products', JSON.stringify(allfavoritesProducts));
      }
    }


  }
  
});
